import React from "react";
import { useParams } from "react-router";
import { LayoutCardHeader } from "src/components/layout";
import LayoutCard from "src/components/layout/layout-card";
import MainLayout from "src/components/layout/main-layout";
import { PreAuthByGatewayCard } from "src/components/shared/PreAuthByGatewayCard";
import { FINAL_MESSAGES_MAP } from "src/constants/finalMessagesMap";

const PreAuthorizationByGatewayPage: React.FC = () => {
  const params = useParams();
  const path = "/" + params["*"];
  const title = FINAL_MESSAGES_MAP[path]?.title;
  const cardTitle = FINAL_MESSAGES_MAP[path]?.cardTitle;
  const cardMessage = FINAL_MESSAGES_MAP[path]?.cardMessage;

  return (
    <MainLayout>
      <LayoutCard>
        <LayoutCardHeader>{title}</LayoutCardHeader>
        <PreAuthByGatewayCard title={cardTitle} message={cardMessage} />
      </LayoutCard>
    </MainLayout>
  );
};

export default PreAuthorizationByGatewayPage;
